import { Navigate } from 'react-router-dom';
import Introduction from '../Introduction';
import useAttendanceSteps, { UseAttendanceSteps } from './vm';
import routes from '../../../../routes/router';

export enum Steps {
  INTRODUCTION,
}

export interface StepsProps extends UseAttendanceSteps {
  currentStep: Steps;
}

const AttendanceSteps = ({ currentStep, ...vmProps }: StepsProps) => {
  const { handleClickIntroductionNext, handleGotoAttendance } = useAttendanceSteps(vmProps);

  switch (currentStep) {
    case Steps.INTRODUCTION:
      return <Introduction onNext={handleClickIntroductionNext} goToNextStep={handleGotoAttendance} />;
    default:
      return <Navigate to={routes.attendance.url()} />;
  }
};

export default AttendanceSteps;
